(() => {
  const CHECKOUT_PARAMS = 'skip_shop_pay=true&shop_pay_checkout_as_guest=true';

  const syncCartCountFromServer = async () => {
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      const count = cart?.item_count ?? 0;
      document.querySelectorAll('cart-icon').forEach((icon) => {
        if (typeof icon.renderCartBubble === 'function') {
          icon.renderCartBubble(count, false);
        }
      });
    } catch (error) {
      /* no-op */
    }
  };

  window.addEventListener('pageshow', () => {
    syncCartCountFromServer();
  });
  if (document.readyState === 'complete') {
    syncCartCountFromServer();
  } else {
    window.addEventListener('load', syncCartCountFromServer, { once: true });
  }

  const clearDrawerState = () => {
    sessionStorage.removeItem('theme-drawer-open');
    document.querySelector('theme-drawer#cart-drawer[open]')?.close?.();
  };

  document.querySelector('[data-sa-cart]')?.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank') return;
    if (link.origin !== window.location.origin) return;
    clearDrawerState();
  });

  const shopOrigin = () => {
    const fromHtml = document.documentElement.getAttribute('data-sa-shop-origin');
    if (fromHtml) return fromHtml.replace(/\/$/, '');
    if (window.Shopify?.shop) return `https://${window.Shopify.shop}`;
    return window.location.origin;
  };

  const checkoutHref = () => `${shopOrigin()}/checkout?${CHECKOUT_PARAMS}`;

  document.addEventListener(
    'click',
    (event) => {
      const btn = event.target.closest('button[name="checkout"]');
      if (!btn || btn.disabled) return;
      const formId = btn.getAttribute('form') || btn.form?.id;
      if (formId !== 'cart-form') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      clearDrawerState();
      window.location.assign(checkoutHref());
    },
    true
  );

  const hideNode = (node) => {
    if (!node) return;
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
    node.hidden = true;
  };

  const isShopPayHaystack = (value) => {
    const hay = String(value || '').toLowerCase();
    if (!hay || hay.includes('paypal')) return false;
    return (
      hay.includes('shop_pay') ||
      hay.includes('shoppay') ||
      hay.includes('shop pay') ||
      hay.includes('buy with shop')
    );
  };

  const hideShopPayWallet = (root) => {
    if (!root) return;

    root.querySelectorAll('.additional-checkout-buttons--sa-hide-shop-pay iframe').forEach((iframe) => {
      const hay = `${iframe.title} ${iframe.name} ${iframe.src}`;
      if (isShopPayHaystack(hay)) {
        hideNode(iframe);
        hideNode(iframe.parentElement);
        hideNode(iframe.parentElement?.parentElement);
      }
    });

    root.querySelectorAll('.additional-checkout-buttons--sa-hide-shop-pay button, .additional-checkout-buttons--sa-hide-shop-pay a').forEach((el) => {
      const hay = `${el.getAttribute('aria-label') || ''} ${el.getAttribute('title') || ''} ${el.textContent || ''}`;
      if (isShopPayHaystack(hay)) {
        hideNode(el.closest('li, div, span') || el);
      }
    });

    root.querySelectorAll('shopify-accelerated-checkout-cart, shopify-accelerated-checkout').forEach((host) => {
      const shadow = host.shadowRoot;
      if (!shadow) return;
      shadow.querySelectorAll('button, a, [role="button"], iframe').forEach((el) => {
        const hay = `${el.getAttribute('aria-label') || ''} ${el.getAttribute('title') || ''} ${el.getAttribute('src') || ''} ${el.textContent || ''}`;
        if (isShopPayHaystack(hay)) {
          hideNode(el.closest('li, div, span') || el);
        }
      });
    });

    root.querySelectorAll('.additional-checkout-buttons--sa-hide-shop-pay .dynamic-checkout__content > div').forEach((row) => {
      const children = [...row.children].filter((child) => child.style.display !== 'none' && !child.hidden);
      if (children.length >= 2) hideNode(children[0]);
    });
  };

  const runHideShopPay = () => {
    document.querySelectorAll('.cart-drawer__summary, .sa-cart__summary-card, .cart__ctas').forEach(hideShopPayWallet);
  };

  const watchCartWallets = () => {
    runHideShopPay();

    if (!window.__saCartWalletObserver) {
      window.__saCartWalletObserver = new MutationObserver(runHideShopPay);
      window.__saCartWalletObserver.observe(document.body, { childList: true, subtree: true });
    }

    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && !drawer.dataset.saShopPayHook) {
      drawer.dataset.saShopPayHook = 'true';
      new MutationObserver(runHideShopPay).observe(drawer, {
        attributes: true,
        attributeFilter: ['open'],
        childList: true,
        subtree: true,
      });
    }

    window.setInterval(() => {
      if (
        document.querySelector('theme-drawer#cart-drawer[open]') ||
        document.querySelector('[data-sa-cart]')
      ) {
        runHideShopPay();
      }
    }, 800);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartWallets);
  } else {
    watchCartWallets();
  }
})();
